import React from 'react';
import {
  Box,
  Flex,
  Heading,
  Text,
  Button,
  Spacer,
  useColorMode,
  useColorModeValue,
  IconButton,
} from '@chakra-ui/react';
import { MoonIcon, SunIcon } from '@chakra-ui/icons';

const Layout = ({ children }) => {
  const { colorMode, toggleColorMode } = useColorMode();

  const bgMain = useColorModeValue('gray.50', 'gray.800');
  const textColor = useColorModeValue('black', 'white');

  return (
    <Flex direction="column" minH="100vh">
      {/* Header */}
      <Box as="header" bg="brand.500" color="white" p={4}>
        <Flex align="center">
          <Heading as="h1" size="lg">
            DPLL Visualizer
          </Heading>
          <Spacer />
          <IconButton
            onClick={toggleColorMode}
            icon={colorMode === 'light' ? <MoonIcon /> : <SunIcon />}
            aria-label="Prepni režim"
            size="sm"
            mr={2}
          />
          <Button
            as="a"
            href="https://forms.gle/515LHj66zS4oXAt38"
            target="_blank"
            rel="noopener noreferrer"
            size="sm"
            colorScheme="yellow"
            variant="solid"
            fontWeight="bold"
          >
            Feedback
          </Button>
        </Flex>
      </Box>

      {/* Main content */}
      <Box as="main" flex="1" bg={bgMain} color={textColor}>
        {children}
      </Box>

      {/* Footer */}
      <Box as="footer" bg="brand.500" color="white" p={4}>
        <Text fontSize="sm">
          © 2025 Záverečná práca DPLL Vis. All rights reserved.
        </Text>
      </Box>
    </Flex>
  );
};

export default Layout;
